import React from 'react';
import { Warning } from '@mui/icons-material';
import { IPayMethod } from 'models';
import { verifyBankAccountMandate } from 'api/PaymentInformationApi';
import { useUserContext } from 'UserContext';
import { useStripe } from '@stripe/react-stripe-js';
import { consoleLogInDev } from 'shared';
import { Colors } from 'library';
import { Card, Link, PillButton, Row, Stack, Text } from 'library/ui';
import PayMethod from 'parent-portal/payments/Components/PayMethod';

export default function PayMethodMandates({
    neededMandates,
    refresh,
}: {
    neededMandates: IPayMethod[];
    refresh: () => void;
}) {
    const { user } = useUserContext();
    const stripeHook = useStripe();

    function onVerifyClick(payMethod: IPayMethod) {
        const customer_id = user?.customer_id;
        verifyBankAccountMandate(stripeHook, payMethod.id, customer_id).then(refresh).catch(consoleLogInDev);
    }

    return (
        <Card tone="error">
            <Stack gap="md">
                <Row gap="sm">
                    <Warning style={{ color: Colors.error, fontSize: 20 }} />
                    <Text weight="bold" tone="error">
                        Action Required: Consent Needed
                    </Text>
                </Row>
                <Text>
                    Re-authorize the following bank accounts by <b>May 15</b> to avoid disruption. After this date,
                    payments will fail and shift posting will be disabled. You can remove old or unused accounts on the
                    <Link to="/payments">payments page</Link>.
                </Text>
                {neededMandates.map((x) => (
                    <Row key={x.id} justify="between">
                        <PayMethod payMethod={x} />
                        <PillButton onClick={() => onVerifyClick(x)} color={Colors.error}>
                            Agree & Consent
                        </PillButton>
                    </Row>
                ))}
            </Stack>
        </Card>
    );
}
